import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Hook to automatically track page views on route changes
 * Usage: Add <PageTracking /> component to your Router
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document or use pathname
    const pageTitle = document.title || location.pathname;
    
    // Track page view
    trackPageView(location.pathname, pageTitle);
  }, [location]);
};

/**
 * Component wrapper for usePageTracking hook
 * Add this inside your Router component
 */
export const PageTracking: React.FC = () => {
  usePageTracking();
  return null;
};

